import { Offer } from "@assets/types"

export const promotionWithQRCode = (item: Offer | undefined) => ['auth-link-activated', 'qrcode'].some(t => item?.tags?.includes(t))